export enum SnackbarMessageTypes {
  Info,
  Warning,
  Error,
  Success,
}

export interface ISnackbarMessage {
  messageText: string;
  messageType: SnackbarMessageTypes;
}

export interface ISnackbar {
  message: ISnackbarMessage;
  seconds?: number;
}

export type SnackbarMessageObserver = (props: ISnackbar) => void;

class SnackbarService {
  observers: SnackbarMessageObserver[] = [];

  public attach(observer: SnackbarMessageObserver) {
    this.observers.push(observer);
  }

  public detach(observer: SnackbarMessageObserver) {
    this.observers = this.observers.filter(function(value: SnackbarMessageObserver) {
      return value !== observer;
    });
  }

  public updateSnackbar(props: ISnackbar) {
    this.observers.map(observer => observer(props));
  }

  public info(message: string) {
    this.updateSnackbar({
      message: {
        messageText: message,
        messageType: SnackbarMessageTypes.Info,
      },
    });
  }

  public warn(message: string) {
    this.updateSnackbar({
      message: {
        messageText: message,
        messageType: SnackbarMessageTypes.Warning,
      },
    });
  }

  public error(err: any) {
    this.updateSnackbar({
      message: {
        messageText: (err && err.toString()) || "Unknown error occurred.",
        messageType: SnackbarMessageTypes.Error,
      },
      seconds: 10000,
    });
  }

  public success(message: string) {
    this.updateSnackbar({
      message: {
        messageText: message,
        messageType: SnackbarMessageTypes.Success,
      },
    });
  }
}

const snackbarService = new SnackbarService();

export default snackbarService;
